(() => {
  const currency = document.currentScript?.dataset.currency;
  const track = (event, details = {}) => {
    if (window.dataLayer) window.dataLayer.push({ event, container: { ...details } });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link) {
      const url = new URL(link.href, window.location.href);
      const method = url.protocol === 'tel:' ? 'phone' : url.protocol === 'mailto:' ? 'email' :
        url.origin === window.location.origin && /\/pages\/contact\/?$/.test(url.pathname) ? 'contact_page' : null;
      if (method) track('container_contact_click', { method });
    }
  });

  // This is checkout intent, not a completed or started checkout/purchase.
  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented || !event.target.matches('form[action*="/cart"]') || event.submitter?.name !== 'checkout') return;
    track('container_checkout_click');
  });

  document.addEventListener('container:cart-added', (event) => {
    const item = event.detail;
    track('container_add_to_cart', {
      variant_id: String(item.variant_id || item.id), product: item.product_title,
      quantity: item.quantity, value: item.price * item.quantity / 100, currency,
    });
  });

  if (document.querySelector('cart-items')) track('container_cart_view');
  if (document.querySelector('[data-contact-success]')) track('container_contact_success');
})();
